import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import InputField from 'dashboard/components/FormControls/InputField';
import Button from 'design-system/components/Button';
import { matchesRegexp, withMessage } from 'lib/utils/formValidation';

const InputSection = styled('div')`
  margin-bottom: ${SPACINGS.base}px;
  width: 348px;
`;

const StyledInputField = styled(InputField)`
  margin-bottom: 0px;
`;

// See: app/models/organization.rb validates :subdomain
const SUBDOMAIN_REGEXP = /^[a-z0-9]+$/;

const validate = {
  // we don't validate presence because you should be able to remove subdomain
  subdomain: withMessage(
    'Only lowercases letters and numbers are permitted',
    matchesRegexp(SUBDOMAIN_REGEXP),
  ),
};

const FormOrganizationSubdomain = ({ handleSubmit, submitting, pristine }: InjectedFormProps) => {
  const lowercase = (value: string) => {
    return value && value.toLowerCase();
  };

  return (
    <form onSubmit={handleSubmit}>
      <InputSection>
        <Field
          component={StyledInputField}
          name='subdomain'
          id='subdomain'
          type='text'
          data-test='form-organization-subdomain__organization-subdomain'
          disabled={submitting}
          normalize={lowercase}
          placeholder='Subdomain'
          validate={validate.subdomain}
        />
      </InputSection>

      <Button
        type='submit'
        data-test='form-organization-subdomain__submit'
        disabled={submitting || pristine}
        isPending={submitting}
        width='button'
      >
        Update subdomain
      </Button>
    </form>
  );
};

export interface OrganizationSubdomainFormData {
  subdomain: string;
}

export default reduxForm<OrganizationSubdomainFormData, {}>({
  form: 'organizationSubdomain',
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
})(FormOrganizationSubdomain);
